import React, {Suspense, useEffect, useState} from 'react';
import {Canvas} from '@react-three/fiber';
import {OrbitControls} from '@react-three/drei';
import ProjectStar from './utility/ProjectStar';
import ProjectDetail from './utility/ProjectDetail';
import {useProjects} from '../../ProjectsContext';
import InfoPage from "../kontekt/InfoPage";
import {Heading} from "@chakra-ui/react"
import GridBackground from "./GridBackground";
import {Link} from 'react-router-dom';
import styles from "./universum.module.css";
import WorksManager from "../worksmanager/WorksManager";

const API_BASE = '/api';

export default function Universe() {
    const {projects, loading} = useProjects();
    const [selectedProject, setSelectedProject] = useState(null);
    const [showInfoPage, setInfoPage] = useState(false);
    const visibleProjects = projects.filter((p) => p.images?.[0] ?? p.image);
    const [currentUser, setCurrentUser] = useState(null);
    const [kontakte, setKontakte] = useState([]);
    const [showWorksManager, setWorksManager] = useState(false);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);

    useEffect(() => {
        fetch("/api/kontakte.php", {
            credentials: "include"
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Kontakte konnten nicht geladen werden");
                }

                return response.json();
            })
            .then((data) => {
                setKontakte(data.contact ?? []);
            })
            .catch((error) => {
                console.error(error);
            })
    }, []);

    useEffect(() => {
        fetch(`${API_BASE}/check.php`, {
            credentials: 'include'
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.authed) {
                    setCurrentUser(data.user);
                }
            })
            .catch(() => setCurrentUser(null));
    }, []);

    const handleLogout = async () => {
        await fetch(`${API_BASE}/logout.php`, {method: 'POST', credentials: 'include'}).catch(() => {
        });
        window.location.href = '/';
    };

    if (loading) {
        return <div style={{width: '100vw', height: '100vh', background: '#ffffff'}}/>;
    }

    return (
        <div style={{width: '100vw', height: '100vh', background: '#ffffff', position: 'relative'}}>
            <div style={HeadingStyle} className="universe-header">
                <Heading fontWeight="normal" size="3xl">Chajan Phuakphong</Heading>
                <div>
                    {kontakte.map((kontakt, index) => (
                        <React.Fragment key={index}>
                            <Heading fontWeight="normal" size="3xl">
                                <a
                                    href={`mailto:${kontakt.email}`}
                                    className={styles.emailLink}
                                >
                                    {kontakt.email}
                                </a>
                            </Heading>

                            <Heading fontWeight="normal" size="3xl">
                                {kontakt.tel}
                            </Heading>
                        </React.Fragment>
                    ))}
                </div>
            </div>
            <div style={buttonRowStyle} className="universe-buttons">
                <button onClick={() => {setSelectedCategoryId(null); setWorksManager(true);}} style={InfoButtonStyle}>
                    index
                </button>
                <button onClick={() => setInfoPage(true)} style={InfoButtonStyle}>about</button>
                {currentUser?.username === 'admin' && (<Link to="/intern" style={contactButtonStyle}>intern</Link>)}
                <button onClick={handleLogout} style={contactButtonStyle}>logout</button>
            </div>

            <Canvas camera={{position: [0, 0, 15], fov: 35}}>
                <color attach="background" args={['#ffffff']}/>
                <ambientLight intensity={0.6}/>
                <pointLight position={[10, 10, 10]} intensity={0.5}/>

                <GridBackground/>

                <Suspense fallback={null}>
                    {visibleProjects.map((project) => (
                        <ProjectStar
                            key={project.id}
                            project={project}
                            isSelected={selectedProject?.id === project.id}
                            onSelect={() => setSelectedProject(project)}
                        />
                    ))}
                </Suspense>

                <OrbitControls
                    enablePan
                    panSpeed={1.2}
                    minDistance={3}
                    maxDistance={50}
                    autoRotate={!selectedProject && !showInfoPage}
                    autoRotateSpeed={0.3}
                />
            </Canvas>
            {showInfoPage && <InfoPage onClose={() => setInfoPage(false)}/>}

            {showWorksManager && (
                <WorksManager
                    initialCategoryId={selectedCategoryId}
                    onClose={() => {
                        setWorksManager(false);
                        setSelectedCategoryId(null);
                    }}
                    onSelectProject={(project) => {
                        setWorksManager(false);
                        setSelectedProject(project);
                    }}
                />
            )}

            {selectedProject && (
                <ProjectDetail
                    project={selectedProject}
                    onClose={() => setSelectedProject(null)}
                    onCategoryClick={(categoryId) => {
                        setSelectedProject(null);
                        setSelectedCategoryId(categoryId);
                        setWorksManager(true);
                    }}
                />
            )}

            <div style={legalFooterStyle}>
                <Link to="/impressum" style={legalLinkStyle}>Impressum</Link>
                <Link to="/datenschutz" style={legalLinkStyle}>Datenschutz</Link>
            </div>
        </div>
    )
        ;
}

const contactButtonStyle = {
    padding: '10px 22px',
    border: '1px solid black',
    background: '#ffffff',
    color: '#111',
    cursor: 'pointer',
    fontSize: '14px',
};

const buttonRowStyle = {
    position: 'absolute',
    top: '20px',
    right: '20px',
    display: 'flex',
    gap: '10px',
    zIndex: 5,
};

const InfoButtonStyle = {
    padding: '10px 22px',
    border: '1px solid black',
    background: '#ffffff',
    color: '#111',
    cursor: 'pointer',
    fontSize: '14px',
};

const legalFooterStyle = {
    position: 'absolute',
    bottom: '16px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: '16px',
    zIndex: 5,
};

const legalLinkStyle = {
    fontSize: '12px',
    color: '#888',
    textDecoration: 'none',
};

const HeadingStyle = {
    position: 'absolute',
    top: '10px',
    left: '1%',
    padding: '10px 22px',
    background: 'transparent',
    color: '#111',
    cursor: 'pointer',
    zIndex: 5,
};

